// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_27WI2","tabItem":"_3V6u8","active":"EeDHf"};